import React, { useEffect, useState } from 'react'
import Formvalidators from '../validators/Formvalidators';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export default function ContactForm() {
    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });
    let [show, setShow]= useState(false)
    let navigate = useNavigate()
    let [errorMessage, setErrorMessage]= useState({
        name:"Name Field Is Required ",
        phone:"Phone Field Is Required ",
        email:"Email Field Is Required ",
        message:"Message Field Is Required ",
    })

    const handleChange = (e) => {
        let {name, value} = e.target;
     
            setErrorMessage((old)=>{
                return{
                    ...old,
                    [name]:Formvalidators(e)
                }
            })
            setForm((old)=>{
                return{
                    ...old,
                    [name]:value
                }
            })
        
    };

    const handleSubmit = async(e) => {
        try {
            e.preventDefault();
            let error = Object.values(errorMessage).find((x)=> x!== "")
            console.log(error);
            
            if(error){
                setShow(true)
            }
            else{
               
                let res = await fetch ("http://34.228.14.188:8000/api/contactus",{
                    method:"POST",
                    headers:{
                        "Content-type":"application/json"
                    },
                    body: JSON.stringify(form)
                })
                res = await res.json()
                if(res.result==="Done"){
                    console.log(res);
                    
                    toast.success("Thank You !! Your Form Successfully  Submit")
                    setTimeout(() => {
                        navigate("/")
                    }, 1000); 
                }
            }
        } catch (error) {
            
        }


         
    };
  return (
    <div className="col-md-6 query-form-user-details">
    <div className="form-container">
        <h3>User Details</h3>
         <form onSubmit={handleSubmit} className="user-form">
            <input
                type="text"
                className={`${show && errorMessage ? "border-danger":""}`}
                name="name"
                placeholder="Your Name*"
                onChange={handleChange}
                required
            />
            {show && errorMessage ? <p>{errorMessage.name}</p>:""}
            <input
                type="email"
                className={`${show && errorMessage ? "border-danger":""}`}
                name="email"
                placeholder="Your Email*"
                onChange={handleChange}
                required
            />
            <input
                type="number"
                className={`${show && errorMessage ? "border-danger":""}`}
                name="phone"
                placeholder="Your Mobile Number*"
                onChange={handleChange}
                required
            />
            <textarea
                className={`${show && errorMessage ? "border-danger":""}`}
                name="message"
                placeholder="Your Comment*"
                onChange={handleChange}
                required
            ></textarea>
            <button type="submit">Submit</button>
        </form>
    </div>
</div>
  )
}
